import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Save, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { API } from "../context/ShopContext";

const SettingsAdmin = ({ authHeaders }) => {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ stripe_mode: "test", site_url: "", stripe_live_key: "" });
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/admin/settings`, authHeaders());
      setSettings(data);
      setForm({ stripe_mode: data.stripe_mode, site_url: data.site_url, stripe_live_key: "" });
    } catch {
      toast.error("Errore caricamento impostazioni");
    }
  }, [authHeaders]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/settings`, form, authHeaders());
      toast.success("Impostazioni salvate");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message);
    } finally {
      setSaving(false);
    }
  };

  if (!settings) {
    return (
      <section className="idm-admin-section" data-testid="admin-settings">
        <h3 className="idm-admin-section-title">Impostazioni</h3>
        <div className="idm-loading"><span className="idm-spinner" /></div>
      </section>
    );
  }

  return (
    <section className="idm-admin-section" data-testid="admin-settings">
      <h3 className="idm-admin-section-title">Impostazioni</h3>
      <p className="idm-admin-section-sub">
        Configurazione pagamenti Stripe e URL del sito (usato nei link delle email: conferma ordine,
        imposta password, recupero password).
      </p>

      <div className="idm-form-grid">
        <div className="idm-field half">
          <label>Modalità Stripe</label>
          <div className="idm-settings-mode" data-testid="settings-stripe-mode">
            <label>
              <input
                type="radio"
                name="stripe_mode"
                checked={form.stripe_mode === "test"}
                onChange={() => setForm({ ...form, stripe_mode: "test" })}
                data-testid="settings-mode-test"
              />
              TEST (carte di prova)
            </label>
            <label>
              <input
                type="radio"
                name="stripe_mode"
                checked={form.stripe_mode === "live"}
                onChange={() => setForm({ ...form, stripe_mode: "live" })}
                data-testid="settings-mode-live"
              />
              LIVE (pagamenti reali)
            </label>
          </div>
          {form.stripe_mode === "live" && (
            <p className="idm-settings-warn" data-testid="settings-live-warning">
              <AlertTriangle size={13} /> In modalità LIVE i clienti pagano con carte reali.
            </p>
          )}
        </div>
        <div className="idm-field half">
          <label>
            Stripe Live key{" "}
            {settings.stripe_live_key_set && (
              <span className="idm-settings-keyset">(impostata: ••••{settings.stripe_live_key_last4})</span>
            )}
          </label>
          <input
            type="password"
            placeholder={settings.stripe_live_key_set ? "Lascia vuoto per non modificarla" : "sk_live_..."}
            value={form.stripe_live_key}
            onChange={(e) => setForm({ ...form, stripe_live_key: e.target.value })}
            data-testid="settings-live-key"
          />
        </div>
        <div className="idm-field">
          <label>Site URL (dominio del sito, usato nei link delle email)</label>
          <input
            placeholder="https://www.ideamedia.org"
            value={form.site_url}
            onChange={(e) => setForm({ ...form, site_url: e.target.value })}
            data-testid="settings-site-url"
          />
        </div>
        <div>
          <button className="idm-btn-yellow" style={{ animation: "none" }} onClick={save} disabled={saving} data-testid="settings-save">
            {saving ? <Loader2 size={15} className="idm-spin" /> : <Save size={15} />} Salva impostazioni
          </button>
        </div>
      </div>
    </section>
  );
};

export default SettingsAdmin;
